export default __webpack_public_path__ + "static/media/icon_ui_questionmark-bg.ce271605.png";